// BookTickets/stages/DateAndTime/lib/dateAndTime.ts

import { startOfDay, isPast, parseISO } from 'date-fns'

export const STORAGE_KEY_DATE = 'book.date'

export function isSpecialDate(d: Date): boolean {
  // 2023-11-01 (months are 0-based; 10 = November)
  return d.getFullYear() === 2023 && d.getMonth() === 10 && d.getDate() === 1
}

export function parseQueryDate(raw: string | null): Date | null {
  if (!raw) return null
  // parseISO reads a bare date (?date=2026-11-01) as local midnight. `new Date`
  // reads it as UTC midnight, which is the day before anywhere west of UTC.
  const iso = parseISO(raw)
  const d = Number.isNaN(iso.getTime()) ? new Date(raw) : iso
  return Number.isNaN(d.getTime()) ? null : d
}

export function clampToTodayIfPast(d: Date): Date {
  return isPast(startOfDay(d)) ? new Date() : d
}

export function resolveCalendarLocale(locale: string): string {
  const map: Record<string, string> = { en: 'en', pt: 'pt', fr: 'fr', es: 'es' }
  return map[locale] ?? 'en'
}
